module.exports = __webpack_public_path__ + "img/papers.37147fcf.svg";